import React from "react";
import {
  Box,
  Typography,
  CircularProgress,
  Fab,
  makeStyles,
} from "@material-ui/core";
import { CssBaseline } from "@material-ui/core";
import clsx from "clsx";
import CheckIcon from "@material-ui/icons/Check";
import { green, red } from "@material-ui/core/colors";
import { ErrorOutline } from "@material-ui/icons";
const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    alignItems: "center",
  },
  wrapper: {
    margin: theme.spacing(1),
    position: "relative",
  },
  linkBtn: {
    textDecoration: "none",
  },
  buttonSuccess: {
    backgroundColor: (props) =>
      !props.loadingcondition && !props.error
        ? `${green[500]} !important`
        : props.error
        ? `${red[500]} !important`
        : `${green[500]} !important`,
    boxShadow: "none",
    color: "inherit !important",
    cursor: "default",
    "&:hover": {
      backgroundColor: (props) =>
        !props.loadingcondition && !props.error
          ? `${green[500]} !important`
          : props.error
          ? `${red[500]} !important`
          : `${green[500]} !important`,
    },
  },
  fabProgress: {
    position: "absolute",
    top: -6,
    left: -6,
    zIndex: 1,
  },
}));
const SuccessPage = ({ loadingcondition, error, tenantCode }) => {
  const classes = useStyles({ error, loadingcondition });
  const buttonClassname = clsx({
    [classes.buttonSuccess]: !loadingcondition,
  });

  return (
    <Box height="100%" width="100%">
      <Box maxWidth="200px" padding={3} position="relative">
        <a href="https://www.growmax.io/">
          <img
            src="https://uploads-ssl.webflow.com/5fba92e02f240050de6a1ccd/5fbe2d1d07b3fc2421d6f39b_growmax_red.svg"
            alt="logo"
            height="100%"
            width="100%"
            style={{ objectFit: "contain", objectPosition: "left" }}
          />
        </a>
      </Box>
      <CssBaseline />
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
      >
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          width="40%"
        >
          <Typography gutterBottom variant="h4" style={{ fontWeight: 500 }}>
            Thank you for signing up!
          </Typography>
          <Box my={3}>
            <div className={classes.root}>
              <div className={classes.wrapper}>
                <Fab aria-label="save" disabled className={buttonClassname}>
                  {!loadingcondition && !error && <CheckIcon />}
                  {error && !loadingcondition && <ErrorOutline />}
                </Fab>

                {loadingcondition && (
                  <CircularProgress size={68} className={classes.fabProgress} />
                )}
              </div>
            </div>
          </Box>

          <Box my={1} />
          {!loadingcondition && !error ? (
            <Typography align="center" gutterBottom variant="subtitle1">
              Your site is ready! Check your email for verification link &
              login. If you didn't receive, please check your{" "}
              <span style={{ color: "#FA292C" }}>promotions</span> or{" "}
              <span style={{ color: "#FA292C" }}>spam</span> folder.
            </Typography>
          ) : !loadingcondition && error ? (
            <Typography align="center" gutterBottom variant="subtitle1">
              There seems to be some error! Let us help you via support chat.
              Please initiate chat now.
            </Typography>
          ) : (
            <Typography align="center" gutterBottom variant="subtitle1">
              Give us few secs to get your site ready! We are setting up things
              for you.
            </Typography>
          )}
        </Box>
      </Box>{" "}
    </Box>
  );
};

export default SuccessPage;
